// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"353":"contact","491":"hero","594":"about","597":"projects","651":"courses"}[chunkId] || chunkId) + "." + {"156":"9301a3fb","241":"dd61e210","353":"4b72fc5e","403":"db94d61c","491":"db852713","594":"fc07dd39","597":"c6637a1a","651":"86ba9157"}[chunkId] + ".chunk.js";
};